import { FileResponse } from "@relode/core/backend/responses";

export class AddJobStep1Details {
    teamId: number;
    hasActiveTeamPlan: boolean;
    externalDescription: string;
    isIntegrated: boolean;
    attachment: FileResponse;
    jobConcurrencyToken: string;
}
